// import { render } from "@testing-library/react";
import React from "react";
import "./aboutMe.css";
import "../App.css";
import aiImg from "../images/DeWatermark.ai_1713524697848.png";

export default function AboutMe() {
  return (
    <div className="myCol">
      <div className="">
        <div className="row g-0 flexible">
          <div className="col-6 col-md-7 myCol">
            <div className="content1">
              <h2 className="gradient-text header-container">
                Data Scientist | Mentor | Speaker | Blogger
              </h2>
              <header className="header-container">
                <h1 className="black-bold">
                  Hello, I’m{" "}
                  <span className="red-text" style={{ color: "#bb9429" }}>
                    Reenal.
                  </span>
                </h1>
              </header>
              <p className="par-content">
                Experienced technologist with a strong 6+ years background in
                software development and 3+ year in data science, adept at
                crafting chatbots and virtual assistants, with a proven track
                record of quickly adapting to emerging technologies and
                translating business requirements into technical solutions.
                Motivated team player with excellent interpersonal skills,
                dedicated to collaborating effectively to achieve optimal
                outcomes while applying advanced data science techniques to
                address complex business and engineering challenges.
              </p>
              {
                <div style={{ paddingLeft: "10%", paddingTop: "1px" }}>
                 
                </div>
              }

              <center>
                <div
                  className="text-center empty-div"
                  style={{
                    paddingLeft: "0px",
                    paddingTop: "0px",
                    //border: "1px solid black",
                    margin: "0px",
                  }}
                >
                  <h2
                    className="gradient-text header-container"
                    style={{ fontWeight: "bolder", fontSize: "3vh" }}
                  >
                    ॥ कर्मण्येवाधिकारस्ते मा फलेषु कदाचन ॥
                  </h2>
                </div>
              </center>
            </div>
          </div>
          <div class="col-6 col-md-5 wrap">
            <div
              className="circle"
              // style={{border: '2px solid red', marginTop: '0px', paddingTop: '0px'}}
            >
              <img src={aiImg} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
